import groupBy from 'lodash/groupBy';

import StatusStackedBar from '../../generic/StatusStackedBar/StatusStackedBar';
import { connectEditor } from '../connect-editor';
import { campaignLineStatuses } from '../constants';

const { DRAFT, READY, PUSHED, LOCKED } = campaignLineStatuses;

function getStatusBarItems(lines) {
  const linesByStatus = groupBy(lines, 'status');
  return [DRAFT, READY, PUSHED, LOCKED].map(status => ({
    status,
    count: linesByStatus[status] ? linesByStatus[status].length : 0,
  }));
}

const mapStateToProps = ({ campaignLinesById }, { business }) => {
  let campaignLines = Object.values(campaignLinesById);
  if (business) {
    campaignLines = campaignLines.filter(
      line => line.product.business === business,
    );
  }
  return {
    items: getStatusBarItems(campaignLines),
  };
};

export default connectEditor(mapStateToProps)(StatusStackedBar);
